<template>
  <div class="foodleap-new-home antialiased">


    <!-- Hero Section -->
    <header class="relative pt-32 pb-20 hero-gradient overflow-hidden">
      <div class="max-w-7xl mx-auto px-8 relative z-10">
        <div class="tw-flex flex-col items-center text-center max-w-4xl mx-auto mb-10">
          <span class="fl-hero-badge inline-flex items-center px-4 py-1.5 rounded-full bg-brand-light-grey text-primary-slate text-xs font-bold tracking-widest uppercase mb-6">
            Global Ecosystem Intelligence
          </span>
          <h1 class="fl-hero-title text-5xl md:text-7xl font-bold tracking-tight text-primary-slate mb-8 leading-[1.1]">
            Explore the global food system transition
          </h1>
          <p class="fl-hero-sub text-xl text-primary-slate/70 font-light max-w-2xl mb-4">
            Visualizing the network of innovators, infrastructure, and capital building the future of sustainable food production and distribution.
          </p>
          <div class="fl-hero-btns tw-flex flex-wrap justify-center gap-4">
            <button
              @click="onHeroCta('Navigate the transitions', '/transitions')"
              class="fl-btn-primary bg-primary-slate text-white px-10 py-4 rounded-full font-bold shadow-xl shadow-primary-slate-20 transition-all tw-flex items-center gap-2">
              Navigate the transitions
              <Icon name="arrow-right" class="fl-arrow-icon"/>
            </button>
            <button @click="onHeroCta('Access real-time insights', '/intelligence')"
                    class="hover:!bg-white fl-btn-secondary bg-brand-light-grey text-primary-slate px-10 py-4 rounded-full font-bold transition-all">
              Access real-time insights
            </button>
            <button @click="onHeroCta('Add your organisation', '/register')" class="fl-btn-secondary bg-white text-primary-slate px-10 py-4 rounded-full font-bold transition-all">
              Add your organisation
            </button>
          </div>
        </div>
      </div>
      <div class="fl-blob-1 absolute -top-24 -right-24 w-96 h-96 bg-secondary-blue/10 rounded-full blur-3xl"></div>
      <div class="fl-blob-2 absolute -bottom-24 -left-24 w-96 h-96 bg-secondary-vibrant-green/10 rounded-full blur-3xl"></div>
    </header>

    <!-- 4 Transitions Strip -->
    <section class="max-w-7xl mx-auto px-8 pt-12 pb-0 animate-on-scroll mb-12">
      <div class="mb-6">
        <span class="inline-flex items-center px-3 py-1 rounded-full bg-primary-green/10 text-primary-green text-xs font-bold tracking-widest uppercase mb-3">
          Navigate the transitions
        </span>
        <h2 class="text-4xl md:text-5xl font-bold text-primary-slate mb-2">The Four shifts defining the Future of Food</h2>
        <p class="text-sm text-primary-slate/60 font-light max-w-xl">Explore the key transitions reshaping the global food system and find your place in the shift.</p>
      </div>
      <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <div
          v-for="(transition, i) in transitions"
          :key="i"
          @click="onTransitionCardClick(transition)"
          class="fl-transition-card group cursor-pointer rounded-xl overflow-hidden border transition-all bg-white"
          :class="transition.borderClass"
          :data-content-name="'Foodleap Shift Card'"
          :data-content-piece="transition.label">
          <!-- Visual header -->
          <div class="relative h-36 tw-flex items-center justify-center overflow-hidden" :class="transition.headerBg">
            <div class="absolute w-32 h-32 rounded-full -top-8 -right-8 blur-2xl opacity-50" :class="transition.iconBg"></div>
            <div class="absolute w-20 h-20 rounded-full bottom-0 -left-4 blur-xl opacity-30" :class="transition.iconBg"></div>
            <div class="w-14 h-14 rounded-2xl tw-flex items-center justify-center relative z-10 shadow-sm group-hover:scale-110 transition-transform duration-200"
                 :class="transition.iconBg">
              <Icon :name="transition.icon" size="24" :class="transition.iconColor"/>
            </div>
          </div>
          <!-- Content -->
          <div class="p-5 border-t" :class="transition.dividerClass">
            <div class="text-[10px] font-bold tracking-widest uppercase mb-1.5" :class="transition.labelColor">{{ transition.label }}</div>
            <h3 class="text-sm font-bold text-primary-slate leading-tight mb-2">{{ transition.title }}</h3>
            <p class="text-xs text-primary-slate/50 font-light leading-snug">{{ transition.desc }}</p>
            <div class="mt-4 tw-flex items-center gap-1 text-xs font-bold" :class="transition.linkColor">
              Explore map
              <Icon name="arrow-right" size="12"/>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Map Section -->
    <!--    <section class="max-w-screen-2xl mx-auto px-8 py-4 animate-on-scroll">
          &lt;!&ndash; Map header &ndash;&gt;
          <div class="tw-flex items-center justify-between mb-3 px-1">
            <div class="tw-flex items-center gap-3">
              <h2 class="text-sm font-bold text-primary-slate">Global Transition Map</h2>
              <span class="text-[10px] font-bold tracking-widest uppercase px-2.5 py-1 rounded-full bg-secondary-yellow/20 text-secondary-yellow">In progress</span>
            </div>
            <div class="tw-flex items-center gap-2">
              <span class="text-[10px] font-semibold text-primary-slate/40">Showing:</span>
              <span class="text-[10px] font-bold px-3 py-1 rounded-full bg-primary-slate text-white">Enablers</span>
              <span class="text-[10px] font-bold px-3 py-1 rounded-full bg-brand-light-grey text-primary-slate/60">Incubators</span>
              <span class="text-[10px] font-bold px-3 py-1 rounded-full bg-brand-light-grey text-primary-slate/60">Accelerators</span>
            </div>
          </div>
          <div class="relative bg-white rounded-lg overflow-hidden shadow-2xl shadow-primary-slate-5 border border-brand-light-grey">
            &lt;!&ndash; Toolbar &ndash;&gt;
            &lt;!&ndash;        <div class="tw-flex items-center justify-between p-4 border-b border-brand-light-grey glass-effect">
                      <div class="tw-flex items-center gap-4 flex-1">
                        <div class="relative w-full max-w-md">
                          <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-primary-slate/40">search</span>
                          <input
                            class="fl-search-input w-full pl-10 pr-4 py-2 bg-brand-light-grey/50 border-none rounded-full text-sm focus:ring-2 focus:ring-primary-slate transition-all"
                            placeholder="Search organisations, tech, or regions..."
                            type="text"
                          />
                        </div>
                        <div class="tw-flex gap-2 overflow-x-auto no-scrollbar">
                          <span class="fl-chip active px-4 py-1.5 rounded-full bg-secondary-vibrant-green text-primary-slate text-xs font-semibold whitespace-nowrap cursor-pointer">Core innovators</span>
                          <span
                            class="fl-chip px-4 py-1.5 rounded-full bg-brand-light-grey text-primary-slate/70 text-xs font-semibold whitespace-nowrap cursor-pointer hover:bg-brand-light-grey-80">Infrastructure</span>
                          <span
                            class="fl-chip px-4 py-1.5 rounded-full bg-brand-light-grey text-primary-slate/70 text-xs font-semibold whitespace-nowrap cursor-pointer hover:bg-brand-light-grey-80">VC/Capital</span>
                          <span
                            class="fl-chip px-4 py-1.5 rounded-full bg-brand-light-grey text-primary-slate/70 text-xs font-semibold whitespace-nowrap cursor-pointer hover:bg-brand-light-grey-80">Government</span>
                        </div>
                      </div>
                      <div class="tw-flex items-center gap-3">
                        <button class="fl-icon-btn p-2 rounded-lg hover:bg-brand-light-grey transition-colors">
                          <span class="material-symbols-outlined text-primary-slate">filter_list</span>
                        </button>
                        <button class="fl-icon-btn p-2 rounded-lg hover:bg-brand-light-grey transition-colors">
                          <span class="material-symbols-outlined text-primary-slate">layers</span>
                        </button>
                      </div>
                    </div>&ndash;&gt;
            &lt;!&ndash; Embed &ndash;&gt;
            <div class="relative h-[750px] w-full bg-brand-light-grey/20 rounded-lg">
              <iframe class="w-full h-full border-none" src="https://platform.foodleap.com/ecosystem-maps/1/embed?apiKey=ds_live_BYlfkEtvKnsWzpHeI1fo"></iframe>
              <div class="absolute bottom-6 right-6 z-20 fl-infobox">
                <div class="bg-white rounded-2xl p-6 max-w-xs shadow-2xl border border-brand-light-grey">
                  <div class="tw-flex items-center gap-3 mb-3">
                    <div class="w-10 h-10 bg-secondary-vibrant-green/20 text-primary-green rounded-xl tw-flex items-center justify-center">
                      <Icon name="bar-chart" size="18"/>
                    </div>
                    <h3 class="text-sm font-bold text-primary-slate leading-tight">Access real-time insights</h3>
                  </div>
                  <p class="text-[11px] text-primary-slate/60 mb-4 leading-relaxed">
                    Live signals from 450+ organisations across the food system transition.
                  </p>
                  <button
                    @click="$router.push('/dashboards/home')"
                    class="fl-btn-dark w-full bg-primary-slate text-white py-2.5 rounded-full text-xs font-bold hover:opacity-90 transition-all mb-2">
                    View Intelligence
                  </button>
                  <button @click="goToRegistration" class="w-full text-primary-green text-[11px] font-bold hover:underline">
                    Add your ecosystem
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>-->

    <!-- Facility Finder Section -->
    <section class="max-w-7xl mx-auto px-8 py-24 border-y border-brand-light-grey bg-white/50">
      <div class="tw-flex flex-col lg:flex-row items-center gap-16">
        <div class="flex-1 space-y-8 animate-on-scroll">
          <span class="inline-flex items-center px-4 py-1.5 rounded-full bg-secondary-blue/10 text-secondary-blue text-xs font-bold tracking-widest uppercase">
            AI Powered Facility Finder
          </span>
          <h2 class="text-4xl md:text-5xl font-bold tracking-tight text-primary-slate leading-[1.2]">
            Find the right pilot facilities for your innovation
          </h2>
          <p class="text-lg text-primary-slate/70 font-light leading-relaxed">
            Talk to our AI-powered Facility Finder to discover test facilities, labs, and equipment tailored to your specific needs. Scaling from lab to market requires the right
            environment.
          </p>
          <button
            @click="$router.push('/facilities')"
            class="fl-btn-launcher tw-flex items-center gap-4 bg-primary-slate text-white pl-6 pr-4 py-4 rounded-full font-bold shadow-xl shadow-primary-slate-20 transition-all group">
            Launch Facility Finder
            <div class="w-10 h-10 bg-primary-green rounded-full tw-flex items-center justify-center text-primary-slate group-hover:scale-110 transition-transform">
              <Icon name="comments" size="20"/>
            </div>
          </button>
        </div>
        <div class="flex-1 relative w-full animate-on-scroll delay-2">
          <div class="fl-chat-card bg-brand-light-grey/20 rounded-lg p-6 border border-brand-light-grey relative overflow-hidden">
            <div class="space-y-4 max-w-md mx-auto">
              <div class="tw-flex gap-3 fl-msg-in">
                <div class="w-8 h-8 rounded-full bg-primary-green shrink-0 tw-flex items-center justify-center">
                  <Icon name="chat-bot" size="12"/>
                </div>
                <div class="bg-white p-4 rounded-2xl rounded-tl-none shadow-sm text-sm text-primary-slate leading-snug">
                  Hello! I can help you find pilot facilities. Are you looking for fermentation, extrusion, or cell-cultivation equipment?
                </div>
              </div>
              <div class="tw-flex flex-col items-end gap-2 fl-msg-out">
                <div class="bg-primary-slate text-white p-4 rounded-2xl rounded-tr-none shadow-sm text-sm leading-snug">
                  I need a precision fermentation pilot plant in Northern Europe for 500L batches.
                </div>
                <div class="text-[10px] text-primary-slate/40 font-bold uppercase tracking-widest mr-2">Sent</div>
              </div>
              <div class="tw-flex gap-3 fl-msg-in">
                <div class="w-8 h-8 rounded-full bg-primary-green shrink-0 tw-flex items-center justify-center">
                  <Icon name="chat-bot" size="12"/>
                </div>
                <div class="bg-white p-4 rounded-2xl rounded-tl-none shadow-sm text-sm text-primary-slate leading-snug">
                  <p class="mb-3 font-bold">I've found 2 matching facilities:</p>
                  <ul class="space-y-2">
                    <li class="tw-flex items-center gap-2 text-primary-green">
                      <Icon name="check-circle" size="12"/>
                      <span class="text-primary-slate">BIV Biotech (Denmark) - 500L+</span>
                    </li>
                    <li class="tw-flex items-center gap-2 text-primary-green">
                      <Icon name="check-circle" size="12"/>
                      <span class="text-primary-slate">VTT Pilot (Finland) - Multiple lines</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="pt-4 border-t border-brand-light-grey">
                <div class="bg-white rounded-full px-4 py-2 tw-flex items-center justify-between border border-brand-light-grey/50">
                  <span class="text-xs text-primary-slate/40">Ask about availability...</span>
                  <Icon name="paper-plane" class="fl-send-icon"/>
                </div>
              </div>
            </div>
          </div>
          <div class="absolute -top-6 -right-6 w-24 h-24 bg-secondary-blue/10 rounded-full blur-2xl"></div>
          <div class="absolute -bottom-6 -left-6 w-24 h-24 bg-primary-green/10 rounded-full blur-2xl"></div>
        </div>
      </div>
    </section>

    <!-- Three Paths -->
    <section class="max-w-7xl mx-auto px-8 py-24">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div
          @click="$router.push('/transitions')"
          class="fl-path-card fl-path-green animate-on-scroll bg-primary-green text-primary-slate p-10 rounded-lg tw-flex flex-col justify-between group cursor-pointer transition-all">
          <div>
            <div class="w-12 h-12 bg-primary-slate/10 rounded-xl tw-flex items-center justify-center mb-12 group-hover:scale-110 transition-transform duration-300">
              <Icon name="location-pin"/>
            </div>
            <h3 class="text-3xl font-bold mb-4">Add your organisation to the map</h3>
            <p class="text-primary-slate/80 font-light mb-8">Ensure global stakeholders can find your technology, facilities, and investment needs.</p>
          </div>
          <button class="tw-flex items-center gap-3 text-lg font-bold border-b-2 border-primary-slate/30 w-fit pb-1 group-hover:border-primary-slate transition-all">
            Add your organisation
            <Icon name="arrow-right" class="fl-north-east"/>
          </button>
        </div>
        <div
          @click="goToRegistration"
          class="fl-path-card animate-on-scroll delay-1 bg-white p-10 rounded-lg tw-flex flex-col justify-between border border-brand-light-grey group cursor-pointer transition-all">
          <div>
            <div
              class="w-12 h-12 bg-secondary-blue/10 text-secondary-blue rounded-xl tw-flex items-center justify-center mb-12 group-hover:rotate-12 transition-transform duration-300">
              <Icon name="compass-2"/>
            </div>
            <h3 class="text-3xl font-bold mb-4 text-primary-slate">Join our communities of food innovators</h3>
            <p class="text-primary-slate/70 font-light mb-8">Explore the diverse network of innovators building the future of sustainable food production and distribution.</p>
          </div>
          <button
            class="tw-flex items-center gap-3 text-lg font-bold border-b-2 border-secondary-blue/20 w-fit pb-1 group-hover:border-secondary-blue transition-all text-secondary-blue">
            Register
            <Icon name="arrow-right" class="fl-north-east"/>
          </button>
        </div>
        <div
          @click="goToRegistration"
          class="fl-path-card animate-on-scroll delay-2 bg-white p-10 rounded-lg tw-flex flex-col justify-between border border-brand-light-grey group cursor-pointer transition-all">
          <div>
            <div
              class="w-12 h-12 bg-secondary-yellow/10 text-secondary-yellow rounded-xl tw-flex items-center justify-center mb-12 group-hover:scale-110 transition-transform duration-300">
              <Icon name="bar-chart"/>
            </div>
            <h3 class="text-3xl font-bold mb-4 text-primary-slate">Understand market drivers</h3>
            <p class="text-primary-slate/70 font-light mb-8">Access data-driven insights into emerging sectors and investment trends.</p>
          </div>
          <button
            class="tw-flex items-center gap-3 text-lg font-bold border-b-2 border-secondary-yellow/20 w-fit pb-1 group-hover:border-secondary-yellow transition-all text-secondary-yellow">
            View insights
            <Icon name="arrow-right" class="fl-north-east"/>
          </button>
        </div>
      </div>
    </section>

    <!-- Products & Services -->
    <section class="py-24 bg-white border-t border-brand-light-grey">
      <div class="max-w-7xl mx-auto px-8">
        <div class="text-center mb-16 animate-on-scroll">
          <span class="text-primary-slate/40 font-black tracking-widest text-xs uppercase mb-4 block">What we offer</span>
          <h2 class="text-4xl md:text-5xl font-bold text-primary-slate">Our products & services</h2>
        </div>
        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div @click="onProductClick('Open Innovation Challenges', '/intelligence')"
               class="fa-product-card animate-on-scroll delay-1 bg-brand-light-grey/30 rounded-lg p-8 border border-brand-light-grey group">
            <div class="w-12 h-12 rounded-xl bg-primary-green/10 tw-flex items-center justify-center mb-6">
              <Icon name="light-bulb" size="22" class="text-primary-green"/>
            </div>
            <h4 class="text-lg font-bold text-primary-slate mb-3">Open Innovation Challenges</h4>
            <p class="text-sm text-primary-slate/60 leading-relaxed">Co-design open innovation challenges with startups across the food transition ecosystem.</p>
          </div>
          <div @click="onProductClick('Transition Reports', '/transition-pulse-report')"
               class="fa-product-card animate-on-scroll delay-2 bg-brand-light-grey/30 rounded-lg p-8 border border-brand-light-grey group">
            <div class="w-12 h-12 rounded-xl bg-secondary-yellow/10 tw-flex items-center justify-center mb-6">
              <Icon name="wave-square" size="22" class="text-secondary-yellow"/>
            </div>
            <h4 class="text-lg font-bold text-primary-slate mb-3">Transition Reports</h4>
            <p class="text-sm text-primary-slate/60 leading-relaxed">In-depth reports on each food system transition — covering key players, investment flows, regulatory shifts,
              and emerging opportunities.</p>
          </div>
          <div @click="onProductClick('Transition Advisory', { path: '/about', hash: '#contact' })"
               class="fa-product-card animate-on-scroll delay-4 bg-brand-light-grey/30 rounded-lg p-8 border border-brand-light-grey group">
            <div class="w-12 h-12 rounded-xl bg-primary-slate/10 tw-flex items-center justify-center mb-6">
              <Icon name="hand-shake" size="22" class="text-primary-slate"/>
            </div>
            <h4 class="text-lg font-bold text-primary-slate mb-3">Transition Advisory</h4>
            <p class="text-sm text-primary-slate/60 leading-relaxed">Bespoke strategy work built on ecosystem intelligence — from transition roadmaps to executive coaching.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Why Join -->
    <section class="max-w-7xl mx-auto px-8 py-24">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-16 text-center">
        <div class="fl-why-item animate-on-scroll group">
          <div class="fl-why-icon w-16 h-16 mx-auto mb-6 text-secondary-blue tw-flex items-center justify-center">
            <Icon name="analysis" size="36"/>
          </div>
          <h4 class="text-xl font-bold mb-3 text-primary-slate">Accelerated Discovery</h4>
          <p class="text-primary-slate/70 font-light">Find partners, technologies, and scaling infrastructure in seconds, not months.</p>
        </div>
        <div class="fl-why-item animate-on-scroll delay-1 group">
          <div class="fl-why-icon w-16 h-16 mx-auto mb-6 text-primary-green tw-flex items-center justify-center">
            <Icon name="circle-nodes" size="36"/>
          </div>
          <h4 class="text-xl font-bold mb-3 text-primary-slate">Global Connectivity</h4>
          <p class="text-primary-slate/70 font-light">Bridge the gap between lab-scale innovation and industrial-scale reality.</p>
        </div>
        <div class="fl-why-item animate-on-scroll delay-2 group">
          <div class="fl-why-icon w-16 h-16 mx-auto mb-6 text-secondary-yellow tw-flex items-center justify-center">
            <Icon name="microscope" size="36"/>
          </div>
          <h4 class="text-xl font-bold mb-3 text-primary-slate">Food Transition Intelligence</h4>
          <p class="text-primary-slate/70 font-light">Make decisions backed by the most comprehensive food system data lake.</p>
        </div>
      </div>
    </section>

    <!-- Sticky Bottom Bar -->
    <div class="fl-sticky-bar fixed bottom-0 left-0 w-full z-50 px-3 md:px-8 pb-4 md:pb-8 pointer-events-none">
      <div
        class="max-w-3xl mx-auto bg-ps-95 text-white rounded-full px-3 md:px-4 py-3 tw-flex items-center justify-between shadow-2xl pointer-events-auto border border-white/10 gap-2">
        <!--        <div class="tw-flex items-center gap-1 px-2 md:px-4 shrink-0" :class="{'border-r border-white/10': true}">
                  <span class="fl-live-dot h-2 w-2 rounded-full bg-secondary-vibrant-green animate-pulse inline-block shrink-0"></span>
                  <span class="text-xs font-bold uppercase tracking-tighter text-white ml-1 hidden sm:inline">Live Data</span>
                </div>-->
        <div class="hidden md:tw-flex items-center gap-6 ml-4">
          <a class="fl-bar-link text-xs font-bold uppercase tracking-widest text-white/60 hover:text-white transition-colors" @click="$router.push('/transitions')">Navigate the
            transitions</a>
          <a class="fl-bar-link text-xs font-bold uppercase tracking-widest text-white/60 hover:text-white transition-colors" @click="$router.push('/intelligence')">Access
            real-time insights</a>
        </div>
        <button
          @click="goToRegistration"
          class="fl-bar-cta bg-primary-green text-primary-slate px-4 md:px-6 py-2 rounded-full text-xs font-bold uppercase tracking-widest transition-all hover:opacity-90 shrink-0 whitespace-nowrap">
          Add your organisation
        </button>
      </div>
    </div>

    <!-- Footer -->
    <SimplifiedFooterFoodleapNew/>
  </div>
</template>


<script>
  import SimplifiedFooterFoodleapNew from '@/components/SimplifiedFooter/SimplifiedFooterFoodleapNew.vue'
  import Icon from '../Icon/Icon.vue'
  import { createImpressionObserver, createScrollDepthTracker, trackFoodleapCta, trackFoodleapInteraction, trackFoodleapPageView, } from '@/util/useFoodleapTracking.js'

  export default {
    name: 'StaticHomeFoodleapNew',
    components: { SimplifiedFooterFoodleapNew, Icon },
    data () {
      return {
        expandedInsightSignals: {},
        insightGroups: [
          {
            key: 'capital_investment',
            label: 'Capital & Investment',
            signals: [
              {
                trend: 'double-up',
                name: 'Standing Ovation funding',
                meta: 'Raised €30 million for dairy proteins',
                articles: [
                  { title: 'Standing Ovation secures $34.2m to scale precision-fermented dairy proteins', source: 'FoodBev Media' },
                  { title: 'Standing Ovation nets $34m, gears up for US launch of casein via precision fermentation', source: 'AgFunder News' },
                  { title: 'Paris-based Standing Ovation raises €30 million to produce dairy proteins through precision fermentation', source: 'EU-Startups' },
                  { title: 'Bel, Danone & French Govt Join $34.2M Funding for Standing Ovation', source: 'Green Queen' },
                  { title: 'Standing Ovation raises $34.2 million to scale up its breakthrough technology for producing dairy proteins', source: 'Financial Post' },
                  { title: 'Danone Ventures rejoint le groupe Bel au capital de la start-up Standing Ovation', source: 'ABC Bourse' },
                  { title: 'Danone rejoint Bel au capital d\'une start-up spécialiste de la protéine du lait', source: 'Boursorama' },
                  { title: 'Standing Ovation lève 34,2 M$ pour la fermentation de précision', source: 'WikiAgri' },
                  { title: 'Standing Ovation lève $34,2 M pour la commercialisation à grande échelle de sa technologie de rupture', source: 'ADVFN' },
                  { title: 'AgriFood Signals: Circulate Capital closes $220m fund, All G GRAS approval, Unilever & McCormick', source: 'AgFunder News' },
                ],
              },
              {
                trend: 'double-up',
                name: 'Alternative protein sector growth',
                meta: 'Transitioning from niche to mainstream',
                articles: [
                  { title: 'Redefining the future of alternative proteins', source: 'Science Business' },
                ],
              },
              {
                trend: 'double-up',
                name: 'EU farmers financing demand',
                meta: '€62 billion unmet demand for financing',
                articles: [
                  { title: 'How corporates, startups and farmers can share risk and drive resilience', source: 'Food Navigator USA' },
                  { title: 'From feed to food: Financing farmers\' protein diversification', source: 'EPC' },
                  { title: 'Alternative Proteins Market Value Chain and Forecast Analysis 2026 to 2035', source: 'OpenPR' },
                  { title: 'Competitive Analysis of Leading and Emerging Companies in the Protein Characterization and Identification Market', source: 'OpenPR' },
                ],
              },
              {
                trend: 'neutral',
                name: 'UK food strategy initiative',
                meta: 'Focus on sustainable food systems',
                articles: [
                  { title: 'UK Food Security Minister: Alternative Proteins \'A Major Opportunity\'', source: 'Green Queen' },
                ],
              },
            ],
          },
          {
            key: 'technology_innovation',
            label: 'Technology & Innovation',
            signals: [
              {
                trend: 'double-up',
                name: 'New plant-based fillet',
                meta: 'Schouten Europe\'s proprietary fibre technology',
                articles: [
                  { title: 'Schouten Europe unveils plant-based fillet using proprietary fibre technology', source: 'FoodBev Media' },
                  { title: 'Schouten harnesses fiber tech for high-protein, plant-based chicken fillet', source: 'Food Ingredients First' },
                ],
              },
              {
                trend: 'double-up',
                name: 'Partnerships for innovation',
                meta: 'Food industry seeks agility and tech',
                articles: [
                  { title: 'Why the food industry can\'t innovate alone anymore', source: 'Bakery and Snacks' },
                  { title: 'Top 10 Food Fermentation Company of the World', source: 'Food Info Tech' },
                ],
              },
              {
                trend: 'up',
                name: 'Mycoprotein factory project',
                meta: 'Advancements in alternative protein production',
                articles: [
                  { title: 'Plenitude: Inside the EU project aiming to build a thriving new value chain for meat-alternatives', source: 'Business Green' },
                ],
              },
              {
                trend: 'up',
                name: 'Precision fermentation growth',
                meta: 'Market projected to grow at 40.57% CAGR',
                articles: [
                  {
                    title: 'Precision Fermentation Market to Reach USD 57.1 Billion by 2032, Driven by Sustainable Protein Innovation and Biotech Advancements',
                    source: 'PR Newswire'
                  },
                ],
              },
            ],
          },
          {
            key: 'policy_regulatory',
            label: 'Policy & Regulatory',
            signals: [
              {
                trend: 'double-up',
                name: 'UK food strategy support',
                meta: 'Government emphasizes alternative proteins',
                articles: [
                  { title: 'UK Food Security Minister: Alternative Proteins \'A Major Opportunity\'', source: 'Green Queen' },
                  { title: 'Op-Ed: How the UK Government Can Build On Its Alternative Protein Progress', source: 'Green Queen' },
                ],
              },
              {
                trend: 'double-up',
                name: 'EU labeling restrictions',
                meta: 'Banning terms like \'steak\' and \'bacon\'',
                articles: [
                  { title: 'EU \'meaty\' names ban: What it means for the future of plant-based and alt-protein', source: 'Food Navigator' },
                  { title: 'EU Bans 31 Meat Names on Plant-Based Products, But \'Veggie Burger\' Saved', source: 'Green Queen' },
                  { title: 'Plant-based brands brace for \'chaos\' after EU rule change', source: 'The Grocer' },
                  { title: 'Plant-based naming dispute: How the EU\'s new rules could disrupt food marketing', source: 'Food Ingredients First' },
                  { title: 'World\'s Largest Food Companies Call on EU to Include Novel Foods in Regulatory Sandboxes', source: 'Green Queen' },
                  { title: 'EU Backs Down on \'Veggie Burger\' Ban, Limits Plant-Based Meat Names', source: 'News Directory 3' },
                  { title: 'Kompromiss bei Fleischersatz - EU will weitreichende Beschränkungen bei Bezeichnungen', source: 'Lebensmittelpraxis' },
                  { title: 'Nachverhandlung: \'Veggie-Burger\'-Verbot wird aufgeweicht', source: 'LTO' },
                  { title: 'EU-Veggie-Namensstreit endet in Kompromiss', source: 'Absatzwirtschaft' },
                  { title: '"Veggie-Burger"-Verbot vorerst gescheitert - doch andere Begriffe sollen verschwinden', source: 'Utopia' },
                  { title: 'Veggie-Burger und Tofu-Wurst sind erlaubt, veganer Speck aber nicht', source: 'Proplanta' },
                  { title: 'EU-Verbot gescheitert: Der Veggie-Burger darf weiter so heißen', source: 'Tagesschau' },
                  { title: 'EU-Namensstreit: "Veggie-Burger" ok, "veganer Speck" ade', source: 'Welt' },
                  { title: 'UK Brands Urged To Push Back Against EU Ban On Meat-Related Names For Vegetarian Products', source: 'KAMCity' },
                  { title: 'UK Brands Urged to Fight EU Food Name Ban', source: 'Asian Trader' },
                ],
              },
              {
                trend: 'double-up',
                name: 'UK economic growth focus',
                meta: 'New food strategy prioritizes alternative proteins',
                articles: [
                  { title: 'Op-Ed: How the UK Government Can Build On Its Alternative Protein Progress', source: 'Green Queen' },
                  { title: 'Food and farming businesses told to get ready for EU trade reset', source: 'Farming UK' },
                  { title: 'Firms Urged to Prepare for EU Agri-Food Deal', source: 'Business News Wales' },
                  { title: 'The right kind of profile?', source: 'Foodservice Footprint' },
                ],
              },
              {
                trend: 'double-up',
                name: 'Amsterdam plant-based initiative',
                meta: 'Aiming for 60% plant-based consumption by 2030',
                articles: [
                  { title: 'Protein transition in Amsterdam - Eunomia', source: 'Eunomia' },
                ],
              },
            ],
          },
          {
            key: 'consumer_market',
            label: 'Consumer & Market',
            signals: [
              {
                trend: 'double-up',
                name: 'Italy\'s plant-based growth',
                meta: '11% increase in consumer base',
                articles: [
                  { title: 'From Salsiccia to Salame, Italians Embrace Plant-Based Food with 11% Growth Since 2023', source: 'Green Queen' },
                ],
              },
              {
                trend: 'double-up',
                name: 'Finland\'s blended meat interest',
                meta: 'Rising sales of plant-based products',
                articles: [
                  { title: 'Tofu, Pulled Oats & Blended Meat: How S Group\'s Shoppers Are Eating More Plants', source: 'Green Queen' },
                ],
              },
              {
                trend: 'double-up',
                name: 'Dutch health trends',
                meta: 'Popularity of functional protein foods',
                articles: [
                  { title: '4 big food trends in The Netherlands', source: 'Food Navigator' },
                ],
              },
              {
                trend: 'up',
                name: 'Global market projection',
                meta: 'Expected to reach USD 61.69 Bn by 2035',
                articles: [
                  { title: 'Alternative Proteins Market Value Chain and Forecast Analysis 2026 to 2035', source: 'OpenPR' },
                  { title: 'Meat Alternatives Market Expected to Reach USD 20.1 Billion by 2036 Amid Rising Vegan and Flexitarian Diet Trends', source: 'OpenPR' },
                  { title: 'Fungal Protein Market Growth to $4.8B by 2033 Driven by Plant-Based Demand', source: 'OpenPR' },
                  { title: 'Plant-Based Beef Market Forecast to Reach USD 45.52 Billion by 2036 as Foodservice Integration Accelerates', source: 'OpenPR' },
                  { title: 'Plant-Based Food & Beverage Ingredients Market Forecast 2026-2036: Global Market to Reach USD 13.96 Billion', source: 'OpenPR' },
                  { title: 'Plant Proteins Market is projected to reach US$ 34 billion by 2031', source: 'OpenPR' },
                  { title: 'It\'s Official: Data Says Plant-Based Milk Is Becoming the Default', source: 'VegNews' },
                ],
              },
            ],
          },
          {
            key: 'environmental',
            label: 'Environmental Impact',
            signals: [
              {
                trend: 'double-up',
                name: 'Amsterdam reducing food emissions',
                meta: 'Promoting plant-based diets for emission cuts',
                articles: [
                  { title: 'Protein transition in Amsterdam - Eunomia', source: 'Eunomia' },
                ],
              },
              {
                trend: 'up',
                name: 'Cultivated meat sustainability',
                meta: 'Sustainable alternative to traditional livestock',
                articles: [
                  { title: 'The Downstream Challenge of Cultivated Meat', source: 'The Chemical Engineer' },
                ],
              },
              {
                trend: 'up',
                name: 'Feed prebiotics for antibiotic-free meat',
                meta: 'Prebiotics transforming livestock productivity',
                articles: [
                  { title: 'Gut Health to Global Scale: How Feed Prebiotics are Transforming Livestock Productivity (2025-2031 Forecast)', source: 'OpenPR' },
                ],
              },
              {
                trend: 'up',
                name: 'Algae-based food market growth',
                meta: '$7.5 billion projected by 2034 at 11.7% CAGR',
                articles: [
                  { title: 'Global Algae-Based Food market report, market size, share, trends, analysis and forecast to 2034', source: 'Stratistics' },
                ],
              },
            ],
          },
        ],
        transitions: [
          {
            label: 'Protein',
            focusKey: 'protein',
            title: 'Protein Diversification',
            desc: 'Navigate the shift in protein sources, formats, consumer adoption, retail strategy, value chain restructuring.',
            icon: 'vial',
            path: '/dashboards/home',
            headerBg: 'bg-primary-green/10',
            borderClass: 'border-primary-green/20 hover:border-primary-green/50',
            dividerClass: 'border-primary-green/10',
            iconBg: 'bg-primary-green/15',
            iconColor: 'text-primary-green',
            labelColor: 'text-primary-green',
            linkColor: 'text-primary-green',
          },
          {
            label: 'Circular',
            focusKey: 'circular',
            title: 'Circular & Resource Efficient Food Systems',
            desc: 'Discover how circularity reduces inputs and costs while unlocking value from waste incl. upcycling, side streams & waste valorisation.',
            icon: 'sync',
            path: '/dashboards/home',
            headerBg: 'bg-secondary-blue/10',
            borderClass: 'border-secondary-blue/20 hover:border-secondary-blue/50',
            dividerClass: 'border-secondary-blue/10',
            iconBg: 'bg-secondary-blue/15',
            iconColor: 'text-secondary-blue',
            labelColor: 'text-secondary-blue',
            linkColor: 'text-secondary-blue',
          },
          {
            label: 'Health',
            focusKey: 'food-infrastructure',
            title: 'Healthy & Functional Food',
            desc: 'Preventive nutrition, nutrient density, metabolic health, public health alignment.',
            icon: 'building',
            path: '/facilities',
            headerBg: 'bg-secondary-yellow/10',
            borderClass: 'border-secondary-yellow/20 hover:border-secondary-yellow/50',
            dividerClass: 'border-secondary-yellow/10',
            iconBg: 'bg-secondary-yellow/15',
            iconColor: 'text-secondary-yellow',
            labelColor: 'text-secondary-yellow',
            linkColor: 'text-secondary-yellow',
          },
          {
            label: 'Nature Positive',
            focusKey: 'regenerative',
            title: 'Nature-Positive Food System',
            desc: 'Unlock practical strategies for nature positive agriculture: soil health economics, biodiversity and carbon markets, input reduction, farm economics',
            icon: 'eco',
            path: '/dashboards/home',
            headerBg: 'bg-secondary-vibrant-green/10',
            borderClass: 'border-secondary-vibrant-green/20 hover:border-secondary-vibrant-green/40',
            dividerClass: 'border-secondary-vibrant-green/20',
            iconBg: 'bg-secondary-vibrant-green/20',
            iconColor: 'text-primary-slate',
            labelColor: 'text-primary-slate/60',
            linkColor: 'text-primary-slate',
          },
        ],
      }
    },
    methods: {
      goToRegistration () {
        this.$router.push('/register')
      },
      onHeroCta (label, path) {
        trackFoodleapCta('Homepage', label, 'Hero')
        this.$router.push(path)
      },
      toggleInsightSignal (groupKey, index) {
        const key = groupKey + '_' + index
        this.expandedInsightSignals = { ...this.expandedInsightSignals, [key]: !this.expandedInsightSignals[key] }
      },
      trendArrow (trend) {
        const map = { 'double-up': '↑↑', up: '↑', neutral: '→', down: '↓', 'double-down': '↓↓' }
        return map[trend] || '→'
      },
      trendColorClass (trend) {
        if (trend === 'up' || trend === 'double-up') return 'text-green-600'
        if (trend === 'down' || trend === 'double-down') return 'text-red-500'
        return 'text-gray-400'
      },
      onTransitionCardClick (transition) {
        trackFoodleapInteraction('Foodleap Shift Card', transition.label)
        this.$router.push({ path: '/transitions', query: { focus: transition.focusKey } })
      },
    },
    mounted () {
      trackFoodleapPageView('/foodleap', 'Foodleap - Home')

      this._scrollTracker = createScrollDepthTracker('Foodleap Home')
      this._scrollTracker.start()

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible')
              this._observer.unobserve(entry.target)
            }
          })
        },
        { threshold: 0.12 }
      )
      this.$el.querySelectorAll('.animate-on-scroll').forEach(el => {
        this._observer.observe(el)
      })

      // Fire a content impression when each shift card enters the viewport
      this._impressionObserver = createImpressionObserver(0.5)
      this.$el.querySelectorAll('.fl-transition-card').forEach(el => {
        this._impressionObserver.observe(el)
      })
    },

    beforeUnmount () {
      if (this._observer) this._observer.disconnect()
      if (this._impressionObserver) this._impressionObserver.disconnect()
      if (this._scrollTracker) this._scrollTracker.stop()
    },
  }
</script>


<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  // ── Keyframes ────────────────────────────────────────────────────────────────

  @keyframes fl-fade-down {
    from {
      opacity: 0;
      transform: translateY(-16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fl-fade-up {
    from {
      opacity: 0;
      transform: translateY(24px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fl-float {
    0%, 100% {
      transform: translateY(0px) scale(1);
    }
    50% {
      transform: translateY(-20px) scale(1.05);
    }
  }

  @keyframes fl-float-slow {
    0%, 100% {
      transform: translateY(0px) scale(1);
    }
    50% {
      transform: translateY(-12px) scale(1.03);
    }
  }

  @keyframes fl-shimmer {
    0% {
      background-position: -200% center;
    }
    100% {
      background-position: 200% center;
    }
  }

  @keyframes fl-slide-up {
    from {
      opacity: 0;
      transform: translateY(32px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fl-bounce-in {
    0% {
      opacity: 0;
      transform: scale(0.7);
    }
    60% {
      transform: scale(1.1);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes fl-glow-pulse {
    0%, 100% {
      box-shadow: 0 0 0 0 rgba(92, 204, 97, 0.4);
    }
    50% {
      box-shadow: 0 0 0 10px rgba(92, 204, 97, 0);
    }
  }

  @keyframes fl-arrow-bounce {
    0%, 100% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(3px, -3px);
    }
  }

  // ── Scroll-reveal ─────────────────────────────────────────────────────────────

  .foodleap-new-home .animate-on-scroll {
    opacity: 0;
    transform: translateY(28px);
    transition: opacity 0.65s cubic-bezier(0.22, 1, 0.36, 1),
    transform 0.65s cubic-bezier(0.22, 1, 0.36, 1);

    &.delay-1 {
      transition-delay: 0.12s;
    }

    &.delay-2 {
      transition-delay: 0.24s;
    }

    &.delay-3 {
      transition-delay: 0.36s;
    }

    &.is-visible {
      opacity: 1;
      transform: translateY(0);
    }
  }

  // ── Component styles ──────────────────────────────────────────────────────────

  .foodleap-new-home {
    font-family: 'Inter', sans-serif;
    background-color: #FFFFFF;
    color: #21244A;

    // Brand color variables
    $ps: #21244A; // primary-slate
    $pg: #5CCC61; // primary-green
    $blg: #D9E2DA; // brand-light-grey
    $svg: #C8F58D; // secondary-vibrant-green
    $sy: #FFC83D; // secondary-yellow
    $sr: #EF374E; // secondary-red
    $sb: #70C1FF; // secondary-blue

    // ── Brand color utilities ────────────────────────────────────────────────

    .bg-primary-slate {
      background-color: $ps;
    }

    .bg-primary-green {
      background-color: $pg;
    }

    .bg-brand-light-grey {
      background-color: $blg;
    }

    .bg-secondary-vibrant-green {
      background-color: $svg;
    }

    .bg-primary-slate\/10 {
      background-color: rgba(33, 36, 74, 0.1);
    }

    .bg-primary-slate\/20 {
      background-color: rgba(33, 36, 74, 0.2);
    }

    .bg-primary-slate\/95 {
      background-color: rgba(33, 36, 74, 0.95);
    }

    .bg-ps-95 {
      background-color: rgba(33, 36, 74, 0.95);
      backdrop-filter: blur(24px);
    }

    .bg-primary-green\/5 {
      background-color: rgba(92, 204, 97, 0.05);
    }

    .bg-primary-green\/10 {
      background-color: rgba(92, 204, 97, 0.1);
    }

    .bg-primary-green\/15 {
      background-color: rgba(92, 204, 97, 0.15);
    }

    .bg-brand-light-grey\/20 {
      background-color: rgba(217, 226, 218, 0.2);
    }

    .bg-brand-light-grey\/30 {
      background-color: rgba(217, 226, 218, 0.3);
    }

    .bg-brand-light-grey\/50 {
      background-color: rgba(217, 226, 218, 0.5);
    }

    .bg-secondary-vibrant-green\/5 {
      background-color: rgba(181, 241, 103, 0.05);
    }

    .bg-secondary-vibrant-green\/10 {
      background-color: rgba(181, 241, 103, 0.1);
    }

    .bg-secondary-vibrant-green\/20 {
      background-color: rgba(181, 241, 103, 0.2);
    }

    .bg-secondary-blue {
      background-color: $sb;
    }

    .bg-secondary-blue\/5 {
      background-color: rgba(112, 193, 255, 0.05);
    }

    .bg-secondary-blue\/10 {
      background-color: rgba(112, 193, 255, 0.1);
    }

    .bg-secondary-blue\/15 {
      background-color: rgba(112, 193, 255, 0.15);
    }

    .bg-secondary-yellow {
      background-color: $sy;
    }

    .bg-secondary-yellow\/5 {
      background-color: rgba(255, 200, 61, 0.05);
    }

    .bg-secondary-yellow\/10 {
      background-color: rgba(255, 200, 61, 0.1);
    }

    .bg-secondary-yellow\/15 {
      background-color: rgba(255, 200, 61, 0.15);
    }

    .text-primary-slate {
      color: $ps;
    }

    .text-primary-green {
      color: $pg;
    }

    .text-secondary-blue {
      color: $sb;
    }

    .text-secondary-yellow {
      color: $sy;
    }

    .text-secondary-vibrant-green {
      color: $svg;
    }

    .text-secondary-red {
      color: $sr;
    }

    .text-primary-slate\/20 {
      color: rgba(33, 36, 74, 0.2);
    }

    .text-primary-slate\/40 {
      color: rgba(33, 36, 74, 0.4);
    }

    .text-primary-slate\/60 {
      color: rgba(33, 36, 74, 0.6);
    }

    .text-primary-slate\/70 {
      color: rgba(33, 36, 74, 0.7);
    }

    .text-primary-slate\/80 {
      color: rgba(33, 36, 74, 0.8);
    }

    .border-primary-green {
      border-color: $pg;
    }

    .border-primary-green\/10 {
      border-color: rgba(92, 204, 97, 0.1);
    }

    .border-primary-green\/20 {
      border-color: rgba(92, 204, 97, 0.2);
    }

    .border-brand-light-grey {
      border-color: $blg;
    }

    .border-brand-light-grey\/50 {
      border-color: rgba(217, 226, 218, 0.5);
    }

    .border-primary-slate\/30 {
      border-color: rgba(33, 36, 74, 0.3);
    }

    .border-secondary-blue\/10 {
      border-color: rgba(112, 193, 255, 0.1);
    }

    .border-secondary-blue\/20 {
      border-color: rgba(112, 193, 255, 0.2);
    }

    .border-secondary-yellow\/10 {
      border-color: rgba(255, 200, 61, 0.1);
    }

    .border-secondary-yellow\/20 {
      border-color: rgba(255, 200, 61, 0.2);
    }

    .border-secondary-vibrant-green\/20 {
      border-color: rgba(181, 241, 103, 0.2);
    }

    .shadow-primary-slate-5 {
      box-shadow: 0 25px 50px -12px rgba(33, 36, 74, 0.05);
    }

    .shadow-primary-slate-20 {
      box-shadow: 0 20px 25px -5px rgba(33, 36, 74, 0.2), 0 8px 10px -6px rgba(33, 36, 74, 0.15);
    }

    .hover\:bg-primary-green\/10:hover {
      background-color: rgba(92, 204, 97, 0.1);
    }

    .hover\:bg-secondary-blue\/10:hover {
      background-color: rgba(112, 193, 255, 0.1);
    }

    .hover\:bg-secondary-yellow\/10:hover {
      background-color: rgba(255, 200, 61, 0.1);
    }

    .hover\:bg-secondary-vibrant-green\/10:hover {
      background-color: rgba(181, 241, 103, 0.1);
    }

    .hover\:bg-brand-light-grey:hover {
      background-color: $blg;
    }

    .hover\:bg-brand-light-grey-80:hover {
      background-color: rgba(217, 226, 218, 0.8);
    }

    .hover\:bg-brand-light-grey\/80:hover {
      background-color: rgba(217, 226, 218, 0.8);
    }

    .hover\:text-primary-green:hover {
      color: $pg;
    }

    .hover\:border-primary-slate:hover {
      border-color: $ps;
    }

    .hover\:border-primary-green\/50:hover {
      border-color: rgba(92, 204, 97, 0.5);
    }

    .hover\:border-primary-green\/60:hover {
      border-color: rgba(92, 204, 97, 0.6);
    }

    .hover\:border-secondary-blue:hover {
      border-color: $sb;
    }

    .hover\:border-secondary-blue\/50:hover {
      border-color: rgba(112, 193, 255, 0.5);
    }

    .hover\:border-secondary-blue\/60:hover {
      border-color: rgba(112, 193, 255, 0.6);
    }

    .hover\:border-secondary-yellow:hover {
      border-color: $sy;
    }

    .hover\:border-secondary-yellow\/50:hover {
      border-color: rgba(255, 200, 61, 0.5);
    }

    .hover\:border-secondary-yellow\/60:hover {
      border-color: rgba(255, 200, 61, 0.6);
    }

    .hover\:border-secondary-vibrant-green\/40:hover {
      border-color: rgba(181, 241, 103, 0.4);
    }

    .focus\:ring-primary-slate:focus {
      --tw-ring-color: rgba(33, 36, 74, 0.5);
    }

    // ── Layout helpers ───────────────────────────────────────────────────────

    .glass-effect {
      background: rgba(255, 255, 255, 0.85);
      backdrop-filter: blur(24px);
    }

    .hero-gradient {
      background: radial-gradient(circle at top right, #D9E2DA 0%, #FFFFFF 100%);
    }

    .no-scrollbar::-webkit-scrollbar {
      display: none;
    }

    .no-scrollbar {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    // ── Nav ──────────────────────────────────────────────────────────────────

    .fl-nav {
      animation: fl-fade-down 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
    }

    .fl-nav-link {
      position: relative;
      transition: color 0.2s;

      &::after {
        content: '';
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 0;
        height: 2px;
        background: $pg;
        transition: width 0.25s cubic-bezier(0.22, 1, 0.36, 1);
      }

      &:hover::after {
        width: 100%;
      }

      &.active::after {
        width: 100%;
      }
    }

    .fl-btn-upgrade {
      transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 16px rgba(92, 204, 97, 0.35);
      }
    }

    // ── Hero ─────────────────────────────────────────────────────────────────

    .fl-hero-badge {
      animation: fl-fade-down 0.55s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
    }

    .fl-hero-title {
      animation: fl-fade-up 0.65s cubic-bezier(0.22, 1, 0.36, 1) 0.25s both;
    }

    .fl-hero-sub {
      animation: fl-fade-up 0.65s cubic-bezier(0.22, 1, 0.36, 1) 0.4s both;
    }

    .fl-hero-btns {
      animation: fl-fade-up 0.65s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both;
    }

    .fl-blob-1 {
      animation: fl-float 9s ease-in-out infinite;
    }

    .fl-blob-2 {
      animation: fl-float-slow 11s ease-in-out infinite reverse;
    }

    .fl-btn-primary {
      position: relative;
      overflow: hidden;
      transition: transform 0.2s, box-shadow 0.2s;

      &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(105deg, transparent 40%, rgba(255, 255, 255, 0.15) 50%, transparent 60%);
        background-size: 200% 100%;
        opacity: 0;
        transition: opacity 0.2s;
      }

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 20px 40px rgba(33, 36, 74, 0.25);

        &::before {
          opacity: 1;
          animation: fl-shimmer 0.6s ease forwards;
        }
      }

      &:active {
        transform: translateY(0);
      }
    }

    .fl-btn-secondary {
      transition: transform 0.2s, background-color 0.2s;

      &:hover {
        transform: translateY(-2px);
        background-color: rgba(217, 226, 218, 0.8);
      }
    }

    .fl-arrow-icon {
      transition: transform 0.25s cubic-bezier(0.22, 1, 0.36, 1);
    }

    .fl-btn-primary:hover .fl-arrow-icon {
      transform: translateX(3px);
    }

    // ── Toolbar chips ────────────────────────────────────────────────────────

    .fl-chip {
      transition: transform 0.18s, background-color 0.18s;

      &:hover {
        transform: translateY(-1px);
      }

      &.active {
        box-shadow: 0 2px 8px rgba(181, 241, 103, 0.4);
      }
    }

    .fl-icon-btn {
      transition: background-color 0.2s, transform 0.2s;

      &:hover {
        transform: scale(1.1);
      }
    }

    // ── Lock info box ────────────────────────────────────────────────────────

    .fl-infobox {
      animation: fl-slide-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.8s both;
    }

    .fl-lock-icon {
      transition: transform 0.3s;
    }

    .fl-btn-dark {
      transition: transform 0.2s, box-shadow 0.2s;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 8px 20px rgba(33, 36, 74, 0.3);
      }
    }

    // ── Facility Finder ──────────────────────────────────────────────────────

    .fl-btn-launcher {
      transition: transform 0.25s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.25s;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 20px 40px rgba(33, 36, 74, 0.2);
      }
    }

    .fl-chat-card {
      animation: fl-float-slow 7s ease-in-out infinite;
    }

    .fl-msg-in {
      animation: fl-fade-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
    }

    .fl-msg-out {
      animation: fl-fade-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.2s both;
    }

    .fl-send-icon {
      transition: transform 0.2s;
      cursor: pointer;

      &:hover {
        transform: translateX(3px) rotate(-15deg);
      }
    }

    // ── Three path cards ─────────────────────────────────────────────────────

    // ── Transition strip cards ──────────────────────────────────────────────

    .fl-transition-card {
      transition: transform 0.25s cubic-bezier(0.22, 1, 0.36, 1),
      box-shadow 0.25s;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 32px rgba(33, 36, 74, 0.08);
      }
    }

    // ── Path cards ───────────────────────────────────────────────────────────

    .fl-path-card {
      transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1),
      box-shadow 0.3s cubic-bezier(0.22, 1, 0.36, 1);

      &:hover {
        transform: translateY(-6px);
      }

      &.fl-path-green:hover {
        box-shadow: 0 24px 48px rgba(92, 204, 97, 0.25);
      }

      &:not(.fl-path-green):hover {
        box-shadow: 0 24px 48px rgba(33, 36, 74, 0.1);
      }
    }

    .fl-north-east {
      transition: transform 0.25s cubic-bezier(0.22, 1, 0.36, 1);
    }

    .group:hover .fl-north-east {
      transform: translate(3px, -3px);
    }

    // ── Insight cards ────────────────────────────────────────────────────────

    .fl-insight-card {
      transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1),
      box-shadow 0.3s,
      border-color 0.3s;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 16px 40px rgba(33, 36, 74, 0.08);
        border-color: rgba(92, 204, 97, 0.4);
      }
    }

    .fl-insight-row {
      transition: background-color 0.2s;
      border-radius: 0.5rem;
      padding-left: 0.5rem;
      margin-left: -0.5rem;
      padding-right: 0.5rem;

      &:hover {
        background-color: rgba(217, 226, 218, 0.2);
      }
    }

    // ── Why Join ─────────────────────────────────────────────────────────────

    .fl-why-item {
      &.is-visible .fl-why-icon {
        animation: fl-bounce-in 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
      }
    }

    .fl-why-icon {
      transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
    }

    .fl-why-item:hover .fl-why-icon {
      transform: scale(1.15) translateY(-4px);
    }

    // ── Sticky bar ───────────────────────────────────────────────────────────

    .fl-sticky-bar {
      animation: fl-slide-up 0.6s cubic-bezier(0.22, 1, 0.36, 1) 1.2s both;
    }

    .fl-live-dot {
      animation: fl-glow-pulse 2s ease-in-out infinite;
    }

    .fl-bar-link {
      transition: color 0.2s, transform 0.2s;
      display: inline-block;

      &:hover {
        transform: translateY(-1px);
      }
    }

    .fl-bar-cta {
      transition: transform 0.2s, box-shadow 0.2s;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 20px rgba(92, 204, 97, 0.4);
      }
    }

    // ── Analytics button ─────────────────────────────────────────────────────

    .fl-btn-analytics {
      transition: transform 0.25s, box-shadow 0.25s;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 16px 40px rgba(33, 36, 74, 0.2);
      }
    }

    // ── Search input ─────────────────────────────────────────────────────────

    .fl-search-input {
      transition: box-shadow 0.2s, background-color 0.2s;

      &:focus {
        background-color: rgba(217, 226, 218, 0.7);
        outline: none;
        box-shadow: 0 0 0 2px rgba(33, 36, 74, 0.25);
      }
    }
  }
</style>
